import React, { useContext } from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import styles from "./Experiences.module.css";

const Experiences = () => {
  const { newTheme } = useContext(ThemeContext);

  // Define experiences in a config-driven way
  const experiences = [
    {
      company: "Pinaca Technologies",
      position: "Software Developer",
      location: "Chennai, TN",
      date: "October 2023 - October 2024",
      responsibilities: [
        "Developed and optimized dynamic, responsive user interfaces using React and JavaScript, enhancing component reusability and improving user experience through advanced state management and efficient UI rendering techniques.",
        "Implemented key front-end features such as multiple forms, form previews, hierarchical user management, and profile access control for the User Management System, improving both usability and functionality.",
        "Enhanced the performance of React applications by reducing page load times and implementing lazy loading, resulting in faster, more efficient UI updates.",
        "Leveraged React Hooks, Redux Toolkit, and Context API to manage state and side effects, improving maintainability and scalability of the front-end architecture.",
      ],
    },
    {
      company: "Indus Net Technology",
      position: "Associate Software Engineer",
      location: "Kolkata, WB",
      date: "July 2022 - July 2023",
      responsibilities: [
        "Enhanced a web application for a life insurance product management system using React.js, Node.js, Express, HTML, and CSS, improving functionality, performance, and overall user experience.",
        "Focused on front-end development with React.js, improving the application's UI/UX design and responsiveness, and conducting testing to ensure smooth performance.",
        "Resolved critical issues and bugs, improving application stability by 20%, ensuring a seamless experience for end users.",
        "Developed and customized user interfaces with JavaScript and Salesforce LWC (Lightning Web Components) for a Gold Loan Management System, tailoring Salesforce objects like Leads, Roles, and Permission Sets for improved functionality.",
      ],
    },
  ];

  return (
    <div className={styles.Experiences}>
      <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
        Experiences
      </h1>
      <div className={styles.borderBottom} />

      {experiences.map((experience, index) => (
        <div key={index} className={styles.container}>
          <div className={styles.position}>
            {experience.company} | {experience.position} |{" "}
            <a href="#">{experience.location}</a>
          </div>
          <div className={styles.date}>{experience.date}</div>
          <fieldset className={styles.responsibilities}>
            <legend>
              <h3>Roles & Responsibilities</h3>
            </legend>
            <ul>
              {experience.responsibilities.map((responsibility, idx) => (
                <li key={idx}>{responsibility}</li>
              ))}
            </ul>
          </fieldset>
        </div>
      ))}

      <br />
    </div>
  );
};

export default Experiences;
